import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Modal,
  Switch,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import _ from "lodash";
import React, { useState } from "react";

import { useModalStyles } from "../../modals/modalStyles";
import "react-datetime/css/react-datetime.css";
import "../../../../theme/custom.css";

export type DestinationSettings = {
  segmentCompatible?: boolean;
};

export type DestinationSettingsModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: (settings: DestinationSettings) => void;
  settings: DestinationSettings;
};

export const DestinationSettingsModal = ({
  open,
  onClose,
  onSave,
  settings,
}: DestinationSettingsModalProps) => {
  const classes = useModalStyles();

  const [settingsToUpdate, setSettingsToUpdate] = useState<DestinationSettings>(
    {}
  );

  if (!open) {
    return null;
  }

  // TODO: this modal's state management is unnecessarily complex because it only manages a single setting that is
  // either true or false. The level of polymorphism is unnecessary and makes the code harder to understand and maintain.
  //
  // We should refactor this component to take a single boolean property as to whether the destination should be
  // Segment compatible, as a strict simple boolean.
  function addSetting(key: "segmentCompatible", value: boolean): void {
    const newSettingsToUpdate = _.extend({}, settingsToUpdate, {
      [key]: value,
    });
    setSettingsToUpdate(newSettingsToUpdate);
  }

  function lookupSetting(key: "segmentCompatible"): boolean {
    if (key in settingsToUpdate) {
      return settingsToUpdate[key] ?? false;
    }

    return settings[key] ?? false;
  }

  function handleSave() {
    onClose();
    onSave(settingsToUpdate);
    setSettingsToUpdate({});
  }

  function handleClose() {
    onClose();
    setSettingsToUpdate({});
  }

  return (
    <Modal onClose={onClose} open={open}>
      <Card className={classes.root}>
        <CardHeader
          title="Event Destinations: Advanced Settings"
          classes={{ action: classes.closeIconAction }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={9}>
              <Typography variant="body1">
                <span className={classes.bold}>
                  Override hardcoded destinations?
                </span>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Switch
                checked={!lookupSetting("segmentCompatible")}
                color="secondary"
                name="enable-destination-for-event"
                onChange={() =>
                  addSetting(
                    "segmentCompatible",
                    !lookupSetting("segmentCompatible")
                  )
                }
                value={!lookupSetting("segmentCompatible")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={() => handleClose()}>CLOSE</Button>

          <Button
            onClick={() => handleSave()}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};
